import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class OrganisationApi {
  static getUserOrganisation() {
    const request = new Request(`${apiUrl}/content/org`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }

  static getOrganisation(id) {
    const request = new Request(`${apiUrl}/cms/organisation/${id}`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }
}

export default OrganisationApi;
